<template>
  <div
    class="remove-warning"
    @click="cancel">

    <div class="container">
      <div class="row">
        <div
          class="notification-box col-12 col-md-3"
          @click.stop>

          <q-icon
            class="warning-icon"
            name="trial"
            width="110px" />

          <h5>
            {{ $t(getLabel) }}
          </h5>
          <p>
            {{ $t(getContent) }}
          </p>

          <div class="warning-controll-buttons">
            <input-button
              class="m-1"
              variant="standardInput"
              hollow
              smaller
              btnStyle="nok-style"
              :inputPlaceholder="$t('Button.cancel')"
              @click="cancel" />

            <input-button
              class="m-1"
              variant="standardInput"
              hollow
              smaller
              conformation
              btnStyle="ok-style"
              :inputPlaceholder="$t('Button.remove')"
              @click="remove" />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QIcon from '@/components/standard/display/QIcon'
import InputButton from '@/components/standard/input/InputButton'

export default {
  methods: {
    remove () {
      this.$emit('remove', this.getRemoveEvent)
    },

    cancel () {
      this.$emit('cancel', { cancel: true })
    }
  },

  computed: {
    getRemoveEvent () {
      return this.removeEvent || {}
    },

    getLabel () {
      return this.label
    },

    getContent () {
      return this.content
    }
  },

  components: {
    'q-icon': QIcon,
    'input-button': InputButton
  },

  props: {
    removeEvent: {
      type: Object,
      required: true,
      default: () => { return {} }
    },

    label: {
      type: String,
      required: true,
      default: ''
    },

    content: {
      type: String,
      required: true,
      default: ''
    }
  }
}
</script>

<style scoped>
.remove-warning {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 100000000;
  background-color: rgba(53, 54, 53, 0.88);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.remove-warning .container .row {
  justify-content: center;
}

.notification-box {
  background-color: #FFFFFF;
  border-radius: 4px;
  padding: 20px 10px;
  text-align: center;
}

.notification-box .warning-icon {
  padding-bottom: 20px;
}

.notification-box h5 {
  color: #FE2B41;
  font-weight: bold;
}

.warning-controll-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/notify/RemoveWarning.vue?d02a73d2